import { Button, Menu, MenuItem } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEventContext } from 'providers/EventProvider';
import React from 'react';

const selectOptions = [1, 3, 5, 7, 10, 20, 50, 100];

const SelectSpeed = () => {
  const { options, updateOptions } = useEventContext();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        disabled={options.isLive}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        endIcon={<ExpandMoreIcon />}
        sx={{
          minWidth: 64,
          height: 32,
          borderRadius: '10px',
          border: '1px solid #ececef',
          color: '#1a1a1a',
          fontWeight: 700,
          px: 1.25,
          '&:hover': { bgcolor: '#fafafa', borderColor: '#e0e0e4' }
        }}
      >
        {options.speed}x
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {selectOptions.map((speed) => (
          <MenuItem
            key={speed}
            selected={speed === options.speed}
            onClick={() => {
              updateOptions({
                ...options,
                speed
              });
              setAnchorEl(null);
            }}
          >
            {speed}x
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SelectSpeed;
